import styled from 'styled-components';
import { display, DisplayProps, WidthProps, width } from 'styled-system';

import { themeGet, isNot, is } from '../../theme/utils';
import { ButtonThemeOverrides } from './Button';
import { BUTTON_SHADOW_IDLE, BUTTON_SHADOW_HOVERED } from './themes/constants';

const ButtonBase = styled.button<ButtonThemeOverrides & DisplayProps & WidthProps>`
  ${is('block')`
    width: 100%;
  `};
  ${width};
  ${display};
  font-family: inherit;
  font-weight: ${themeGet.fontWeight('normal')};
  font-size: ${themeGet.fontSize(6)};
  transition: ${themeGet.transition('all', 'fast')};
  ${isNot('noShadow')`
    box-shadow: ${BUTTON_SHADOW_IDLE};
    &:hover {
      box-shadow: ${BUTTON_SHADOW_HOVERED};
    }
    &: active {
      box-shadow: none;
    }
  `};

  margin: 0;
  padding: 10px ${themeGet.space(4)};

  height: ${themeGet.misc('buttonHeight')};
  line-height: 1;

  border-radius: ${themeGet.misc('borderRadius')};
  border: none;

  text-transform: none;
  text-align: center;
  text-decoration: none;

  cursor: pointer;
  vertical-align: middle;
  user-select: none;
  white-space: nowrap;

  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);

  background-color: transparent;
  &::-moz-focus-inner,
  &[type='button']::-moz-focus-inner,
  &[type='reset']::-moz-focus-inner,
  &[type='submit']::-moz-focus-inner {
    border-style: none;
    padding: 0;
  }

  &:focus,
  &.focus {
    outline: 0;
  }

  &:-moz-focusring,
  &[type='button']:-moz-focusring,
  &[type='reset']:-moz-focusring,
  &[type='submit']:-moz-focusring {
    outline: 0;
  }
`;

export default ButtonBase;
